import { ReactNode } from 'react';

export interface Step {
	id: string | number;
	title?: string;
	content?: ReactNode;
	isDisabled?: boolean;
	className?: string;
}

export enum StepperOrientationEnum {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical',
}

export interface StepperWrapperProps {
	steps: Step[];
	currentStep: number;
	onStepChange?: (stepIndex: number) => void;
	className?: string;
	includeHeader?: boolean;
	orientation?: StepperOrientationEnum;
	header?: ReactNode;
}
